import React, { useState, useRef, useContext, useEffect } from 'react';
import { coreAxios } from "utilities/axios";
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { MasterButton } from "components/Buttons/MasterButton";
import  DeleteModalTwo  from "components/Modal/DeleteModalTwo";
import { useSelector, useDispatch } from "react-redux";
import { TableDetail } from 'components/Table/TableDetail';
//NEW
import AuthContext from  "../../context/AuthContext";
import { InputField } from "components/InputField/Input";
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { ChallanTableForm } from 'components/Table/ChallanTableForm';
import { Table } from 'components/Table/Table';
import { NameColumn, TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import { RequisitionValidationSchema } from 'utilities/ValidationSchema/RequisitionValidationSchema';
import useSAUDataTable from './hook/useSAUDataTable';
import { toast as TOAST } from 'react-toastify';
import { AddSoftAsset, UpdateSoftAsset, GetSoftAssetDetail, DeleteSoftAsset } from 'services/softAsset/softAsset.service';
import { DeleteAssignment } from 'services/assignment/assignment.service';
import { GetVendorNameList } from 'services/vendor/vendor.service';
import { GetBrandList } from 'services/other/brand.service';
import { GetCategoryList } from 'services/other/category.service';
import { GetPermissions, GetUnits } from 'services/user/user.service';
import { GetEmployeeNameList } from 'services/employee/employee.service';
import { GetDepartmentList } from "services/other/department.service";
import { GetCurrencyList } from 'services/other/currency.service';

import './ViewDemo.css';
const BASE_URL = process.env.REACT_APP_MAIN_URL


const SoftAsset = () => {
    const toast = useRef(null);

    const [updateData, setUpdateData] = useState(null); // * state for update data
    const [showDetail, setShowDetail] = useState(false); //* state for form modal
    const { softAssetAdd } = useSelector((state) => state.softAssetAdd);
    const { softAssetUpdate } = useSelector((state) => state.softAssetUpdate);
    const { assetList } = useSelector((state) => state.assetList);
    const { softAssetDetail, softAssetDetailLoading } = useSelector((state) => state.softAssetDetail);
    const { vendorNameList } = useSelector((state) => state.vendorNameList);
    const { brandList, brandListLoading } = useSelector((state) => state.brandList);
    const { categoryList, categoryListLoading } = useSelector((state) => state.categoryList);
    const { employeeNameList } = useSelector((state) => state.employeeNameList);
    const { departmentList } = useSelector((state) => state.departmentList);
    const { currencyList } = useSelector((state) => state.currencyList);
    const { unitList } = useSelector((state) => state.units);


    const dispatch = useDispatch();

    // Get FrontEndPermission
    const { permissionList, permissionListLoading } = useSelector((state) => state.permissionList);
    // Get Asset List
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [autoCurrencyFilteredValue, setAutoCurrencyFilteredValue] = useState([]);
    const [autoLocalVendorFilteredValue, setAutoLocalVendorFilteredValue] = useState([]);
    const [autoOriginalVendorFilteredValue, setAutoOriginalVendorFilteredValue] = useState([]);

    const [date, setDate] =useState(new Date());
    const [selectedData, setSelectedData] = useState([])
    const [showForm, setShowForm] = useState(false); //* state for form modal
    // hook
    const [deleteSAUID, setDeleteSAUID] = useState();
    const [showDeleteSAUModal, setShowDeleteSAUModal] = useState(false);

    const { user } = useContext(AuthContext);

    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        name: "",
        original_vendor: "",
        local_vendor: "",
        purchase_date: "",
        purchase_cost: "",
        currency: "",
        license_period_from: "",
        license_period_till: "",
        next_renewal: "",
        sau: [
            {
                id: 0,
                unit: "",
                department: "",
                contact_person: "",
            },
        ],
    };

    const updateInitialValue = {
        ...softAssetDetail,
        original_vendor: vendorNameList?.find((value) => value.id === softAssetDetail?.original_vendor) || "",
        local_vendor: vendorNameList?.find((value) => value.id === softAssetDetail?.local_vendor) || "",
        purchase_date: softAssetDetail?.purchase_date ? new Date(softAssetDetail?.purchase_date) : "",
        currency: currencyList?.find((value) => value.id === softAssetDetail?.currency) || "",
        license_period_from: softAssetDetail?.license_period_from ? new Date(softAssetDetail?.license_period_from) : "",
        license_period_till: softAssetDetail?.license_period_till ? new Date(softAssetDetail?.license_period_till) : "",
        next_renewal: softAssetDetail?.next_renewal ? new Date(softAssetDetail?.next_renewal) : "",
        sau: softAssetDetail?.sau?.length == 0 ? [
            {
                id: 0,
                unit: "",
                department: "",
                contact_person: "",
            }
        ] : softAssetDetail?.sau?.map((value) =>{
            return {
                ...value,
                unit: unitList?.find((unit) => unit.id === value?.unit) || "",
                department: departmentList?.find((department) => department.id === value?.department) || "",
                contact_person: employeeNameList?.find((unit) => unit.id === value?.contact_person) || "",
            }
        }),
    };

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue,
        // validationSchema: RequisitionValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            const modifiedData = {
                ...values,
                original_vendor: values?.original_vendor?.id || null,
                local_vendor: values?.local_vendor?.id || null,
                purchase_cost: parseFloat(values?.purchase_cost) || 0.0,
                currency: values?.currency?.id || null,
                sau: values.sau.map((values) => {
                    return{
                        ...values,
                        unit: values?.unit?.id || null,
                        department: values?.department?.id || null,
                        contact_person: values?.contact_person?.id || null,
                    }
                }),
            }
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const { modalSAUTableColumns, modalSAUTableActionButton } = useSAUDataTable(
        formik, 
        setDeleteSAUID, 
        setShowDeleteSAUModal, 
        setShowForm, 
        setUpdateData,
    );

    const updateSoftAsset = async (asset) => {
        await dispatch(GetSoftAssetDetail(asset?.id))
        // await dispatch(GetEmployeeNameList());
        setShowForm(true); // * set the form to true
        setUpdateData(softAssetDetail);
    };

    const confirmDeleteSAUDetail = async () => {
        const { id, asset } = deleteSAUID;
        await dispatch(DeleteAssignment(id)); //calling
        // setUpdateData(chalan);
        setShowDeleteSAUModal(false);
        await dispatch(GetSoftAssetDetail(asset))
        // await dispatch(GetRequisitionItems(asset)); //calling
    };

    const DeleteModal =  (event, id) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteSoftAsset(id));
                fetchData();
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    // form submit handler
    const handelSubmit = async (values) => {
        if(updateData){
            await dispatch(UpdateSoftAsset(values)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddSoftAsset(values)).then(() => {
            hideModal();
            return
        });
    };

    const softAssetDetails = async (asset) => {
        setShowDetail(true); // * set the form to true
        // dispatch(GetChalanDetail(asset?.id))
        await dispatch(GetSoftAssetDetail(asset))
    };

    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
        setShowDetail(false);
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    // Call always on render
    useEffect(() => {
        dispatch(GetPermissions());
    }, [user, ])

    useEffect(() => {
        dispatch(GetCategoryList());
        dispatch(GetVendorNameList());
        dispatch(GetBrandList());
        dispatch(GetEmployeeNameList());
        dispatch(GetDepartmentList());
        dispatch(GetUnits());
        dispatch(GetCurrencyList());
    }, [showForm, ])

    useEffect(() => {
        fetchData();
      }, [softAssetAdd, softAssetUpdate]);
    
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await coreAxios.get(`${BASE_URL}/api/soft-asset-list/`);
            setData(response.data);
        } catch (error) {
            console.error('Error fetching data: ', error);
        } finally {
            setLoading(false);
        }
    };

    // columns of the table with header name
    const tableColumns = [
        { field: "name", header: "Name", sortableBody: NameColumn },
        { field: "unit_name", header: "Unit", sortableBody: TextColumn },
        { field: "original_vendor_name", header: "Original Vendor", sortableBody: TextColumn },
        { field: "local_vendor_name", header: "Local Vendor", sortableBody: TextColumn },
        { field: "purchase_date_only", header: "Purchase Date", sortableBody: TextColumn },
        { field: "purchase_cost", header: "Purchase Cost", sortableBody: TextColumn },
        { field: "license_period_from_only", header: "License Start", sortableBody: TextColumn },
        { field: "license_period_till_only", header: "License End", sortableBody: TextColumn },
        { field: "next_renewal", header: "Next renewal", sortableBody: TextColumn },
    ];

    const searchCurrency = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && currencyList !== undefined) {
                setAutoCurrencyFilteredValue([...currencyList]);
            } else {
                setAutoCurrencyFilteredValue(
                    currencyList?.filter((currency) => {
                        return currency.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchLocalVendor = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && vendorNameList !== undefined) {
                setAutoLocalVendorFilteredValue([...vendorNameList]);
            } else {
                setAutoLocalVendorFilteredValue(
                    vendorNameList?.filter((vendor) => {
                        return vendor.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const searchOriginalVendor = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && vendorNameList !== undefined) {
                setAutoOriginalVendorFilteredValue([...vendorNameList]);
            } else {
                setAutoOriginalVendorFilteredValue(
                    vendorNameList?.filter((vendor) => {
                        return vendor.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "name",
            name: "name",
            value: "name",
            type: "text",
            labelFor: "name",
            label: "Name",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-4",
        },
        {
            id: "original_vendor",
            name: "original_vendor",
            type: "select",
            labelFor: "original_vendor",
            label: "Select Original Vendor",
            required: false,
            className: "col-12 md:col-4",
            autoFilteredValue: autoOriginalVendorFilteredValue,
            autoCompleteMethod: searchOriginalVendor,
            selectedAutoValue: vendorNameList,
        },
        {
            id: "local_vendor",
            name: "local_vendor",
            type: "select",
            labelFor: "local_vendor",
            label: "Select Local Vendor",
            required: false,
            className: "col-12 md:col-4",
            autoFilteredValue: autoLocalVendorFilteredValue,
            autoCompleteMethod: searchLocalVendor,
            selectedAutoValue: vendorNameList,
        },
        {
            id: "purchase_date",
            name: "purchase_date",
            value: "purchase_date",
            type: "date",
            labelFor: "purchase_date",
            label: "Purchase Date",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-4",
        },
        {
            id: "purchase_cost",
            name: "purchase_cost",
            value: "purchase_cost",
            type: "text",
            labelFor: "purchase_cost",
            label: "Purchase Cost",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-4",
        },
        {
            id: "currency",
            name: "currency",
            type: "select",
            labelFor: "currency",
            label: "Select Currency",
            required: false,
            className: "col-12 md:col-4",
            autoFilteredValue: autoCurrencyFilteredValue,
            autoCompleteMethod: searchCurrency,
            selectedAutoValue: currencyList,
        },
        {
            id: "license_period_from",
            name: "license_period_from",
            value: "license_period_from",
            type: "date",
            labelFor: "license_period_from",
            label: "License Period From",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-4",
        },
        {
            id: "license_period_till",
            name: "license_period_till",
            value: "license_period_till",
            type: "date",
            labelFor: "license_period_till",
            label: "License Period Till",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-4",
        },
        {
            id: "next_renewal",
            name: "next_renewal",
            value: "next_renewal",
            type: "date",
            labelFor: "next_renewal",
            label: "Next Renewal Date",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-4",
        },
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {
                        permissionList[0]?.update_permissions.includes(user?.user_type) ? 
                        <>
                            <Button 
                                tooltip="Update" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                                icon="pi pi-pencil" className="p-button-rounded p-button-primary mr-2" onClick={() => updateSoftAsset(rowData)} 
                            />
                        </> : <></>
                    }
                    {
                        // <Button 
                        // icon="pi pi-list" 
                        // className="p-button-outlined p-button-info mr-2" 
                        // onClick={(e) => {
                        //     softAssetDetails(rowData)
                        // }}
                        // />
                    }
                    {
                        permissionList[0]?.delete_permissions.includes(user?.user_type) ? 
                        <>
                            <Toast ref={toast} /> 
                            <ConfirmPopup />
                            <Button 
                                tooltip="Delete" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                                icon="pi pi-trash" className="p-button-rounded p-button-warning mr-2" 
                                onClick={(e) => { DeleteModal(e, rowData.id); }} 
                                disabled= {false} 
                            />
                        </> : <></>
                    }  
                </div>
            </>
        );
    }

    return (
        <>
            <Table
                tableHeaderName="IT Software Assets"
                tableColumns={tableColumns}
                data={data}
                loading={loading}
                dataKey="id"
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
                //Search
                searchField
                //Row select
                isRowSelectable={false}
                rows={50}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                //Toolbar
                exportBtn={false}
                toolbarPermissions={permissionList[0]}
            />
            <Dialog
                visible={showForm}
                style={{ width: "1400px" }}
                header={`${updateData ? "Update" : "Create"} IT Software Asset`}
                className="p-fluid"
                onHide={hideModal}
                position="top"
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                <form onSubmit={formik.handleSubmit} className={`grid grid-cols-4 mt-2 gap-x-3`}>
                    {inputData.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (

                        <div key={id} className={`p-field ${className}`} >
                            <InputField
                                id={id}
                                type={type}
                                required={required}
                                name={name}
                                errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                                label={label}
                                labelFor={labelFor}
                                rows={rows}
                                value={formik.values[name]}
                                autoCompleteMethod={autoCompleteMethod}
                                autoFilteredValue={autoFilteredValue}
                                onChange={(...args) => {
                                    !onChange && formik.handleChange(...args);
                                    onChange?.(...args);
                                }}
                                onBlur={onBlur}
                                onClose={() => formik.setErrors({})}
                                {...rest}
                            />
                        </div>
                    ))}
                    <Divider align="center">
                        <span className="p-tag" style={{fontSize: '12px'}}>Software Users</span>
                    </Divider>
                    <div className="col-12">
                        <div className="w-full">
                            <ChallanTableForm
                                emptyMessage="No data found"
                                tableColumns={modalSAUTableColumns}
                                data={formik.values.sau}
                                loading={brandListLoading}
                                dataKey="sauID"
                                actionButtonWidth={10}
                                actionButton={modalSAUTableActionButton}
                            />
                        </div>
                    </div>
                    <MasterButton resetForm={resetForm} update={updateData} loading={loading} col1={8} col2={updateData ? 6 : 7} col3={4}/>
                    <DeleteModalTwo
                        visibleModal={showDeleteSAUModal}
                        header="Confirm"
                        onHide={() => setShowDeleteSAUModal(false)}
                        multiItem={false}
                        confirmDelete={confirmDeleteSAUDetail}
                        item={deleteSAUID}
                        loading={softAssetDetailLoading}
                        message="Are you sure you want to delete this asset user item? This Cannot be undone!"
                    />
                </form>
            </Dialog>
        </>
    );
};

export default SoftAsset;
